import React, { useEffect, useRef } from 'react';
import * as echarts from 'echarts';
import './GaugeChart.css';

const GaugeChart = () => {
  const chartRef = useRef(null);

  useEffect(() => {
    // 初始化图表实例
    const chartInstance = echarts.init(chartRef.current);

    // 配置项
    const option = {
      title: {
        text: '综合绩效完成率',
        left: 'center',
        textStyle: {
          fontSize: 14,
          fontWeight: 'normal'
        }
      },
      tooltip: {
        formatter: '{a} <br/>{b} : {c}%'
      },
      series: [
        {
          name: '绩效指标',
          type: 'gauge',
          min: 0,
          max: 100,
          splitNumber: 10,
          radius: '80%',
          axisLine: {
            lineStyle: {
              width: 8,
              color: [
                [0.6, '#3B82F6'],  // 蓝色
                [0.8, '#F59E0B'],  // 金色
                [1, '#EF4444']     // 红色
              ]
            }
          },
          pointer: {
            itemStyle: {
              color: 'auto'
            }
          },
          axisTick: {
            distance: -3,
            length: 4,
            lineStyle: {
              color: '#fff',
              width: 2
            }
          },
          splitLine: {
            distance: -3,
            length: 8,
            lineStyle: {
              color: '#fff',
              width: 2
            }
          },
          axisLabel: {
            color: 'inherit',
            distance: 25,
            fontSize: 10
          },
          detail: {
            valueAnimation: true,
            formatter: '{value}%',
            color: 'inherit',
            fontSize: 24
          },
          data: [
            {
              value: 87.5,
              name: '完成率'
            }
          ]
        }
      ]
    };

    // 设置配置项
    chartInstance.setOption(option);

    // 更新指针动画
    let currentValue = 0;
    const targetValue = 87.5;
    const interval = setInterval(() => {
      currentValue += 1;
      if (currentValue >= targetValue) {
        clearInterval(interval);
      }
      chartInstance.setOption({
        series: [{
          data: [{ value: currentValue, name: '完成率' }]
        }]
      });
    }, 30);

    // 响应窗口大小变化
    const handleResize = () => {
      chartInstance.resize();
    };
    
    window.addEventListener('resize', handleResize);

    // 清理函数
    return () => {
      window.removeEventListener('resize', handleResize);
      clearInterval(interval);
      chartInstance.dispose();
    };
  }, []);

  return <div ref={chartRef} className="gauge-chart"></div>;
};

export default GaugeChart;